import ComponentManager from '@/Management/ComponentManager';
import UserBaseUIListener from '@/UIListener/UserBaseUIListener';

export default class UserGroupUIListener extends UserBaseUIListener {

    constructor() {
        super();
    }
}

ComponentManager.setUIListener('UserGroupUIListener', UserGroupUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.UserGroupUIListener', UserGroupUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');